
import React, { RefObject, forwardRef } from 'react';
import UploadDropzone, { UploadDropzoneRef } from '../UploadDropzone';
import ImagePreview from '../ImagePreview';
import { UploadState } from './types';

interface ImageUploadContentProps {
  state: UploadState;
  handleFileSelection: (file: File) => void;
  removeSelectedImage: () => void;
  allowedTypes: string[];
  maxSizeMB: number;
  aspectRatio: number;
  previewSize: 'sm' | 'md' | 'lg';
  triggerFileInput?: () => void;
  fileInputRef?: RefObject<HTMLInputElement>;
  autoUpload?: boolean;
}

const ImageUploadContent = forwardRef<UploadDropzoneRef, ImageUploadContentProps>(({
  state,
  handleFileSelection,
  removeSelectedImage,
  allowedTypes,
  maxSizeMB,
  aspectRatio,
  previewSize,
  triggerFileInput,
  fileInputRef,
  autoUpload = false
}, ref) => {
  return (
    <div className="flex flex-col items-center justify-center">
      {!state.selectedFile ? (
        <UploadDropzone
          ref={ref}
          onFileSelected={handleFileSelection}
          allowedTypes={allowedTypes}
          maxSizeMB={maxSizeMB}
          triggerFileInput={triggerFileInput}
          fileInputRef={fileInputRef}
          autoUpload={autoUpload}
        />
      ) : (
        <ImagePreview 
          file={state.selectedFile}
          previewUrl={state.previewUrl!}
          uploadStatus={state.uploadStatus}
          uploadProgress={state.uploadProgress}
          errorMessage={state.errorMessage}
          aspectRatio={aspectRatio}
          previewSize={previewSize}
          onRemove={removeSelectedImage}
        />
      )}
    </div>
  );
});

ImageUploadContent.displayName = 'ImageUploadContent';

export default ImageUploadContent;
